import { BlocklyError } from './blockly-error';
function areWeTestingWithJest() {
    return process.env.JEST_WORKER_ID !== undefined;
}
/**
 * @function
 * @param expression - строка, xPath по которой будем искать в блоке нужный элемент
 * @return string
 * у Node, которая в тестах, есть только одно поле - текущее,
 * поэтому ей не нужно указывать, кто создал эту xml.
 * Браузер более разборчивый, ему нужно указать создателя.
 * Поэтому тут мы подменяем выражение для тестов, убирая blockly
 */
export function setupExpression(expression) {
    if (areWeTestingWithJest()) {
        return expression.replace(/blockly:/g, '');
    }
    return expression;
}
export function xpathConverter(block, expression) {
    const validExpression = setupExpression(expression); // грязный хак для тестов
    //Нужен для того, чтобы в Mozilla могло парсится
    const evaluator = new XPathEvaluator();
    try {
        return evaluator.evaluate(validExpression, block, (ns) => ns === 'blockly' ? 'https://developers.google.com/blockly/xml' : null, XPathResult.ANY_TYPE, null);
    }
    catch (e) {
        console.error('xpathConverter', e);
        throw new BlocklyError('xpathConverter', 'что-то не то с браузером');
    }
}
export function xpathTextContentConverter2String(block, name) {
    const value = xpathConverter(block, `./*[@name="${name}"]`).iterateNext()
        ?.textContent;
    if (!value) {
        throw new BlocklyError('xpathTextContentParser', `${name} can't find`);
    }
    return value;
}
export function xpathTextContentConverter2Number(block, name) {
    return parseFloat(xpathTextContentConverter2String(block, name));
}
export function xpathElementConverter(block, name) {
    try {
        const value = xpathConverter(block, `./blockly:${name}`).iterateNext();
        // if (!value) {
        //     throw new BlocklyError('xpathElementConverter-0', `Заполнен не весь блок`);
        // }
        return value;
    }
    catch (e) {
        throw new BlocklyError('xpathElementConverter-1', e);
    }
}
